// ── Dashboard layout constants ────────────────────────────────────────────────

/** Number of tasks visible in PrepCenter before the "+N more upcoming" overflow line. */
export const DASHBOARD_PREP_VISIBLE_TASKS = 1;
